import { useAppContext } from '@/core/hooks';
import { NoPermissionAccess } from '@/modules/403/NoPermissionAccess';

export const WithAuthorize = (Component: React.FC, permission: string) => {
  const AuthorizedComponent = (props: any) => {
    const { hasPermission } = useAppContext();
    if (hasPermission(permission)) {
      return <Component {...props} />;
    }
    return <NoPermissionAccess />;
  };

  AuthorizedComponent.displayName = `WithAuthorize(${
    Component.displayName || Component.name || 'Component'
  })`;

  return AuthorizedComponent;
};
